import React from 'react';
import { displayOnlyShift } from 'services/helpers/shift';
import { useRegion } from 'common/hooks/region';
import cn from 'classnames';
import { formatDateTime } from 'services/helpers/format-date';
import { ContainerType, ShippingLine } from 'types/Shipping';
import { PerDiem } from './types';

interface PerDiemWordingProps {
  perDiem: PerDiem;
  shippingLines: ShippingLine[];
  containerTypes: ContainerType[];
}

export const PerDiemWording: React.FC<PerDiemWordingProps> = (props) => {
  const { perDiem, shippingLines, containerTypes } = props;

  const availabilityMapping: { [key: string]: string } = {
    yes: 'accepts',
    no: 'no longer accepts',
    dual: 'only accepts dual transaction for',
    na: 'acceptance is unknown for',
    iksu: 'only accepts IKSU for',
  };

  const region = useRegion();

  if (!perDiem.new_last_update) return <p>Not available</p>;
  const containerType = containerTypes.find((ct) => ct.key === perDiem.container_type);
  const shippingLine = shippingLines.find((sl) => sl.key === perDiem.shipping_line);

  return (
    <>
      <b>{formatDateTime(perDiem.new_last_update, '', region.timeZone)}</b>
      {': '}
      <span
        className={cn({
          'text-red-900': perDiem.new_availability === 'no',
          'text-green-700': perDiem.new_availability === 'yes',
          'text-orange-700': perDiem.new_availability === 'dual',
        })}
      >
        {availabilityMapping[perDiem.new_availability]}
      </span>
      {` ${containerType?.name} - ${shippingLine?.name} on ${formatDateTime(
        perDiem.date,
        '',
        region.timeZone
      )} ${displayOnlyShift(perDiem.shift)}`}
    </>
  );
};
PerDiemWording.displayName = 'TerminalScreenshots.TimeRangeContent.PerDiemWording';
